import styled from "styled-components";

export const ViewBillingAndPurchaseOrderWrapper = styled.div`
  margin: 0 0;
`;
